import styled from '@emotion/styled';
import {css} from '@emotion/react';

type Props = {
  hasShadow: boolean;
  hasHoverEffect: boolean;
};

// PRIMARY
export const CardPrimaryBorderWrapper = styled.div<Props>`
  flex: 1;
  border-radius: ${({theme}) => theme.border.radius.md};
  border: 2px solid ${({theme}) => theme.color.primary_10};
  background-color: ${({theme}) => theme.color.white};
  box-shadow: ${({theme, hasShadow}) =>
    hasShadow ? theme.boxShadow.primary : 'none'};

  ${({theme, hasHoverEffect}) => {
    if (hasHoverEffect) {
      return css`
        &:hover {
          cursor: pointer;
          border-color: ${theme.color.primary_70};
          box-shadow: ${theme.boxShadow.primary};
        }
      `;
    }
  }}
`;

// WHITE
export const CardWhiteBorderWrapper = styled.div<Props>`
  flex: 1;
  border-radius: ${({theme}) => theme.border.radius.md};
  border: 2px solid ${({theme}) => theme.color.white};
  background-color: ${({theme}) => theme.color.neutral.grey_50};
  box-shadow: ${({theme, hasShadow}) =>
    hasShadow ? theme.boxShadow.primary : 'none'};
  overflow: hidden;

  ${({theme, hasHoverEffect}) => {
    if (hasHoverEffect) {
      return css`
        &:hover {
          cursor: pointer;
          border-color: ${theme.color.secondary_70};
          box-shadow: ${theme.boxShadow.primary};
        }
      `;
    }
  }}
`;

// GREY
export const CardGreyBorderWrapper = styled.div<Props>`
  flex: 1;
  border-radius: ${({theme}) => theme.border.radius.xs};
  border: 1px solid ${({theme}) => theme.color.neutral.grey_100};
  background-color: ${({theme}) => theme.color.neutral.grey_50};
  box-shadow: ${({theme, hasShadow}) =>
    hasShadow ? theme.boxShadow.primary : 'none'};
`;
